var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useQuery } from '@apollo/client';
import { useCompanyFeatures } from 'app/domains/companies';
import { AssistantChatKind } from 'shared/domains/apollo/generated/types';
import { GetPromptUsagesDocument, PromptLibraryListPromptsDocument } from './Queries.gql';
export function usePrompts() {
    var _a;
    const { isFeatureAvailable } = useCompanyFeatures();
    const isApprovalWorkflowPromptsAvailable = isFeatureAvailable('document-assistant:workflows');
    const kinds = isApprovalWorkflowPromptsAvailable
        ? [AssistantChatKind.Regular, AssistantChatKind.Tabular, AssistantChatKind.ApprovalWorkflow]
        : [AssistantChatKind.Regular, AssistantChatKind.Tabular];
    const _b = useQuery(PromptLibraryListPromptsDocument, { variables: { kinds } }), { data } = _b, rest = __rest(_b, ["data"]);
    const prompts = (_a = data === null || data === void 0 ? void 0 : data.prompts.items) !== null && _a !== void 0 ? _a : [];
    return Object.assign({ prompts }, rest);
}
export function usePromptUsage() {
    const { data } = useQuery(GetPromptUsagesDocument);
    return (data === null || data === void 0 ? void 0 : data.promptUsages) || [];
}
